module.exports = __webpack_public_path__ + "static/media/chronicles-of-the-guayaki-indians-pierre-clastres.0f4db4c6.jpg";